module.exports = __webpack_public_path__ + "static/media/1.1324f75d.jpg";